module.exports = __webpack_public_path__ + "img/13057901000161.253d095d.png";